/* src/app/shared-module/components/share-property-confirm-dialog/share-property-confirm-dialog.component.scss */
:host {
  display: block;
}
.sp-dialog-shell {
  overflow: hidden;
  border-radius: 18px;
  background: var(--ion-color-secondary);
  border: 1px solid var(--ion-color-light-tint);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
}
.sp-dialog-header {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 18px 18px 10px;
}
.sp-dialog-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: var(--ion-color-primary-tint);
  flex-shrink: 0;
}
.sp-dialog-icon ion-icon {
  font-size: 22px;
  color: var(--ion-color-primary);
}
.sp-dialog-title-wrap {
  min-width: 0;
}
.sp-dialog-title {
  margin: 0;
  padding: 0;
  color: var(--ion-color-secondary-shade);
  font-size: 20px;
  font-weight: 700;
  line-height: 1.25;
}
.sp-dialog-subtitle {
  margin: 4px 0 0;
  color: var(--ion-color-medium-shade);
  font-size: 13px;
  line-height: 1.4;
}
.sp-dialog-content {
  padding: 0 18px 8px;
}
.sp-dialog-message {
  margin: 0;
  color: var(--ion-color-secondary-shade);
  font-size: 15px;
  line-height: 1.6;
}
.sp-dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 0 18px 18px;
}
.sp-btn {
  min-width: 108px;
  height: 42px;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
}
.sp-btn-cancel {
  color: var(--ion-color-secondary-shade) !important;
  border-color: var(--ion-color-light-shade) !important;
  background: var(--ion-color-secondary) !important;
}
.sp-btn-confirm {
  background: var(--ion-color-primary) !important;
  color: var(--ion-color-secondary) !important;
}
@media (max-width: 480px) {
  .sp-dialog-header,
  .sp-dialog-content,
  .sp-dialog-actions {
    padding-left: 14px;
    padding-right: 14px;
  }
  .sp-dialog-actions {
    flex-direction: column-reverse;
  }
  .sp-btn {
    width: 100%;
  }
}
/*# sourceMappingURL=share-property-confirm-dialog.component.css.map */
